import { ReactNode } from 'react'

import EmptyImage from '@/assets/images/empty-view.svg?react'
import { cn } from '@/utils/style'

interface EmptyViewProps {
  title?: ReactNode
  content?: ReactNode
  action?: ReactNode
  imageSize?: 'small' | 'medium'
  className?: string
}

export function EmptyView({
  title,
  content,
  action,
  imageSize = 'medium',
  className,
}: EmptyViewProps) {
  return (
    <div
      className={cn('w-full h-full flex flex-col items-center justify-center p-[32px]', className)}
    >
      <EmptyImage
        className={cn(
          'mb-1',
          imageSize === 'small' && 'w-[64px] h-[64px]',
          imageSize === 'medium' && 'w-[120px] h-[120px]',
        )}
      />
      {title && <div className="t-bold mb-1 text-primary">{title}</div>}
      {content && <div className={cn('t-sm text-secondary', action && 'mb-1')}>{content}</div>}
      {action}
    </div>
  )
}
